import type { AuthorFragment } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const authorTypeMessages = defineMessages({
  app: {
    defaultMessage: 'App',
    description: 'author type title',
  },
  unknown: {
    defaultMessage: 'Unknown',
    description: 'author type title',
  },
  user: {
    defaultMessage: 'User',
    description: 'author type title',
  },
})

/**
 * Records with no author reach this with `undefined` (and, via `groupBy`, with
 * the stringified key), so the fallback has to be a real branch: without it the
 * exhaustive switch returned `undefined` and rendered an empty heading.
 */
export function translateAuthorType(
  intl: IntlShape,
  type: AuthorFragment['__typename'] | null | undefined,
): string {
  switch (type) {
    case 'App':
      return intl.formatMessage(authorTypeMessages.app)
    case 'User':
      return intl.formatMessage(authorTypeMessages.user)
    default:
      return intl.formatMessage(authorTypeMessages.unknown)
  }
}
